export class Marketplace {
  id: string;
  name: string;
  shortName: string;
  url: string;
}
